<template>
    <div class="sidebar-background">
        <div class="row align-items-end">
            <img src="../../assets/UT_Logo_2400_Sta_White_EN.png"
                width="50%"
                class="col-sm-6 img-pos"
                alt="UTLogo">
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.sidebar-background {
    height: 100%;
    overflow-x: hidden;
    display: block;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background: url('../../assets/Sidebar-background.jpg'), rgba(0,0,0,.7);
    background-size: cover;
    background-blend-mode: multiply;
    background-repeat: no-repeat;
    background-position-x: 15%;
    position:fixed;
    max-width:inherit;
}
.row {
    height: 100%;
}
.img-pos {
  bottom: 0;
  margin-right: auto;
  width: 50%;
  float: bottom;
}
</style>